export const defaultInfo = {}

export const defaultAttachmentsToReuse = {
  attachments: null,
  draft: null
}

export const DEFAULT_JOB_LOADING = false
export const DEFAULT_EXCLUDE_IDS = []
export const DEFAULT_JOB_FOR_APPLICATION = null
export const DEFAULT_DISPLAY_JOB_FOR_APPLICATION_FORM = false
export const DEFAULT_ENABLE_JOB_FOR_APPLICATION = true

export default {
  visible: false,
  submitting: false,
  submitted: false,
  errors: {},
  rate: {},
  type: null,
  info: defaultInfo,
  attachmentsToReuse: defaultAttachmentsToReuse,
  jobLoading: DEFAULT_JOB_LOADING,
  jobForApplication: DEFAULT_JOB_FOR_APPLICATION,
  excludeIds: DEFAULT_EXCLUDE_IDS,
  displayJobForApplicationForm: DEFAULT_DISPLAY_JOB_FOR_APPLICATION_FORM,
  enableJobForApplication: DEFAULT_ENABLE_JOB_FOR_APPLICATION
}
